module.exports = __webpack_public_path__ + "static/media/HBTC-WHT.554d7b3e.svg";